// extracted by mini-css-extract-plugin
export default {"permissions_table":"Permissions_permissions_table__RgfUk","checkbox_wrapper":"Permissions_checkbox_wrapper__5Vj6q"};